<template>
  <q-menu
    v-model="model"
    anchor="bottom right"
    self="top right"
    :offset="[0, 8]"
    transition-show="jump-down"
    transition-hide="jump-up"
    no-parent-event
  >
    <q-card class="min-w-[27.75rem] overflow-hidden shadow-2">
      <div
        class="row items-center justify-between px-16 py-20 text-neutral-10 bg-primary-admin"
      >
        <div class="row items-center gap-8 text-neutral-10">
          <IconNotification class="size-24 text-white" />
          <h2 class="text-headline-2">Notificações</h2>
        </div>
        <q-btn dense flat round icon="close" @click="model = false" />
      </div>

      <div>
        <q-item v-ripple clickable class="!px-16 !py-24">
          <q-item-section avatar>
            <q-avatar
              class="bg-primary-admin/10 text-primary-admin"
              size="40px"
            >
              <IconCheckNotify class="size-24 text-primary-admin" />
            </q-avatar>
          </q-item-section>

          <q-item-section>
            <div class="row gap-8 items-center mb-8">
              <div
                class="text-caps-2 text-neutral-60 text-nowrap rounded border border-neutral-100/10 py-[0.35px] px-4"
              >
                EVIDÊNCIA APROVADA
              </div>
              <div class="text-headline-4 text-neutral-40">
                10/02/2025 às 08:10
              </div>
            </div>
            <div class="text-headline-2 text-neutral-100">
              Assessment de Qualidade
            </div>
          </q-item-section>
        </q-item>
      </div>
    </q-card>
  </q-menu>
</template>

<script setup>
import { computed } from 'vue'
import IconCheckNotify from 'public/icons/check_notify.svg'
import IconNotification from 'public/icons/notification.svg'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue'])

const model = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})
</script>

<style scoped>
.q-menu {
  background: none;
}
</style>
